/* Carrello in stile UpCart (snippets/eq-cart-*.liquid): codice sconto, timer della fascia, "continua lo shopping".
   I codici si applicano con l'API Ajax di Shopify: POST /cart/update.js { discount: "CODICE1,CODICE2" }
   (lista completa). Un codice non applicabile viene tolto subito e mostrato come errore. */
(function () {
  if (window.eqCartReady) return;
  window.eqCartReady = true;

  var ROOT = '[data-eq-discount]';
  var QUICK_CART = '.quick-cart[data-section-id]';
  var CART_PAGE = '.cart.page';
  /* parti del carrello laterale che il tema non ridisegna da solo quando cambia lo sconto */
  var ZONES = ['[data-eq-discount-codes]', '[data-eq-checkout-label]'];
  var SUBTOTAL = '.quick-cart__footer-subtotal';
  var SYNC_DELAY_MS = 300;
  /* fascia: 10 minuti dalla prima pagina vista nella sessione, come UpCart */
  var TIMER_KEY = 'eq_cart_timer_start';
  var TIMER_SECONDS = 600;
  var busy = false;
  var syncTimer = null;

  function url(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + path;
  }

  function sameCode(a, b) {
    return a.toLowerCase() === b.toLowerCase();
  }

  /* ---------- codice sconto ---------- */

  function getCodes() {
    return fetch(url('cart.js'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.discount_codes || []).map(function (d) { return d.code; });
      });
  }

  function setCodes(codes) {
    return fetch(url('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update ' + r.status);
      return r.json();
    });
  }

  function isApplied(cart, code) {
    return (cart.discount_codes || []).some(function (d) {
      return sameCode(d.code, code) && d.applicable;
    });
  }

  function showMessage(root, key, isError) {
    var el = root.querySelector('[data-eq-discount-msg]');
    el.textContent = key ? root.getAttribute('data-msg-' + key) : '';
    el.classList.toggle('is-error', !!isError);
  }

  /* Ridisegna i codici applicati e il pulsante col totale dalla sezione renderizzata da Shopify */
  function syncZones() {
    var section = document.querySelector(QUICK_CART);
    if (!section) return Promise.resolve();
    var sectionId = section.getAttribute('data-section-id');
    return fetch(url('cart?section_id=' + encodeURIComponent(sectionId)), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ZONES.forEach(function (sel) {
          var current = section.querySelector(sel);
          var fresh = doc.querySelector(sel);
          if (current && fresh) current.innerHTML = fresh.innerHTML;
        });
      });
  }

  /* Pagina /cart: si ricarica. Carrello laterale: il tema ridisegna articoli e subtotale su questo evento
     (hook previsto per le app), il resto lo ridisegna syncZones. */
  function refreshCart(root) {
    if (root.closest(CART_PAGE)) {
      window.location.reload();
      return Promise.resolve();
    }
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    return syncZones();
  }

  function run(root, task) {
    if (busy) return;
    busy = true;
    root.classList.add('is-loading');
    var done = function () { busy = false; root.classList.remove('is-loading'); };
    task()
      .catch(function () { showMessage(root, 'error', true); })
      .then(done, done);
  }

  function apply(root) {
    var input = root.querySelector('[data-eq-discount-input]');
    var code = input.value.trim().toUpperCase();
    if (!code) return;
    run(root, function () {
      return getCodes().then(function (current) {
        if (current.some(function (c) { return sameCode(c, code); })) return true;
        return setCodes(current.concat(code)).then(function (cart) {
          if (isApplied(cart, code)) return true;
          return setCodes(current).then(function () { return false; });
        });
      }).then(function (ok) {
        if (ok) input.value = '';
        showMessage(root, ok ? 'applied' : 'invalid', !ok);
        return refreshCart(root);
      });
    });
  }

  function remove(root, code) {
    run(root, function () {
      return getCodes().then(function (current) {
        return setCodes(current.filter(function (c) { return !sameCode(c, code); }));
      }).then(function () {
        showMessage(root, '');
        return refreshCart(root);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-eq-discount-apply]');
    if (applyBtn) {
      e.preventDefault();
      apply(applyBtn.closest(ROOT));
      return;
    }
    var removeBtn = e.target.closest('[data-eq-discount-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.closest(ROOT), removeBtn.getAttribute('data-eq-discount-remove'));
      return;
    }
    if (e.target.closest('[data-eq-continue]')) {
      e.preventDefault();
      var close = document.querySelector('.quick-cart__close-icon');
      if (close) close.click();
    }
  });

  /* Invio nel campo: applica il codice invece di inviare il form (che porta al checkout) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches('[data-eq-discount-input]')) return;
    e.preventDefault();
    apply(e.target.closest(ROOT));
  });

  /* ---------- fascia con timer ---------- */

  function timerStart() {
    try {
      var saved = parseInt(sessionStorage.getItem(TIMER_KEY), 10);
      if (saved) return saved;
      var now = Date.now();
      sessionStorage.setItem(TIMER_KEY, String(now));
      return now;
    } catch (err) {
      window.eqCartTimerStart = window.eqCartTimerStart || Date.now();
      return window.eqCartTimerStart;
    }
  }

  var startedAt = timerStart();

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function renderTimer() {
    var left = Math.max(0, TIMER_SECONDS - Math.floor((Date.now() - startedAt) / 1000));
    var label = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    Array.prototype.forEach.call(document.querySelectorAll('[data-eq-announcement]'), function (el) {
      /* scrive solo se cambia: l'osservatore qui sotto reagisce a ogni modifica del carrello */
      if (el.hidden !== (left === 0)) el.hidden = left === 0;
      var t = el.querySelector('[data-eq-timer]');
      if (t && t.textContent !== label) t.textContent = label;
    });
    return left;
  }

  if (renderTimer() > 0) {
    var tick = setInterval(function () {
      if (renderTimer() === 0) clearInterval(tick);
    }, 1000);
  }

  /* ---------- allineamento dopo gli aggiornamenti del tema ---------- */

  var quickCart = document.querySelector(QUICK_CART);
  if (!quickCart) return;
  new MutationObserver(function (mutations) {
    renderTimer();
    var touched = mutations.some(function (m) {
      var node = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      return node && node.closest(SUBTOTAL);
    });
    if (!touched || busy) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncZones, SYNC_DELAY_MS);
  }).observe(quickCart, { childList: true, subtree: true, characterData: true });
})();
